import Bill from '../images/Bill.jpg';
import BillLoser from '../images/Bill_Loser.jpg';
import BruceLee from '../images/bruce-lee.jpg';
import BruceLeeLoser from '../images/Bruce_Lee_Loser.jpg';
import ButchCoolidge from '../images/Butch Coolidge.jpeg';
import ButchCoolidgeLoser from '../images/Butch_Coolidge_Loser.jpg';
import Calvin from '../images/Callvin.jpg';
import CalvinLose from '../images/Calvin_Loser.jpg';
import CharlesManson from '../images/Charles_Manson.jpeg';
import CharlesMansonLoser from '../images/Charles_Mason_Loser.jpg';
import DaisyDomergue from '../images/Daisy_Domergue.jpg';
import DaisyDomergueLoser from '../images/Daisy_Domergue_Loser.jpeg';
import ElleDriver from '../images/Elle_Driver.jpg';
import ElleDriverLoser from '../images/Elle_Driver_Loser.jpg';
import HansLanda from '../images/Hans_Landa.jpg';
import HansLandaLoser from '../images/Hans_Landa_Loser.jpeg';
import FreddyNewandyke from '../images/Freddy_Newandyke.jpg';
import FreddyNewandykeLoser from '../images/Freddy_Newandyke_Loser.jpg';
import JulesWinnfield from '../images/Jules_Winnfield.png';
import JulesWinnfieldLoser from '../images/Jules_Winnfield_Loser.jpg';
import LouisGara from '../images/Louis_Gara.jpg';
import LouisGaraLoser from '../images/Louis_Gara_Loser.jpg';
import MarcellusWallace from '../images/Marcellus_Wallace.jpeg';
import MarcellusWallaceLoser from '../images/Marcellus_Wallace_Loser.jpeg';
import ORen from '../images/O-Ren.jpg';
import ORenLoser from '../images/O-Ren_Loser.jpg';
import StuntmanMike from '../images/Stuntman_Mike.jpeg';
import StuntmanMikeLoser from '../images/Stuntman_Mike_Death.png';
import VicVega from '../images/Vic_Vega.jpg';
import VicVegaLoser from '../images/Vic_Vega_Loser.jpg';
import VincentVega from '../images/Vincent_Vega.jpg';
import VincentVegaLoser from '../images/Vincen_ Vega_Loser.jpg';

const Characters = [
  {
    name: 'Bill',
    src: [Bill, BillLoser],
  },
  {
    name: 'Bruce Lee',
    src: [BruceLee, BruceLeeLoser],
  },
  {
    name: 'Butch Coolidge',
    src: [ButchCoolidge, ButchCoolidgeLoser],
  },
  {
    name: 'Callvin',
    src: [Calvin, CalvinLose],
  },
  {
    name: 'Charles Manson',
    src: [CharlesManson, CharlesMansonLoser],
  },
  {
    name: 'Daisy Domergue',
    src: [DaisyDomergue, DaisyDomergueLoser],
  },
  {
    name: 'Elle Driver',
    src: [ElleDriver, ElleDriverLoser],
  },
  {
    name: 'Freddy Newandyke',
    src: [FreddyNewandyke, FreddyNewandykeLoser],
  },
  {
    name: 'Hans Landa',
    src: [HansLanda,
      HansLandaLoser],
  },
  {
    name: 'Jules Winnfield',
    src: [JulesWinnfield, JulesWinnfieldLoser],
  },
  {
    name: 'Louis Gara',
    src: [LouisGara, LouisGaraLoser],
  },
  {
    name: 'Marcellus Wallace',
    src: [MarcellusWallace, MarcellusWallaceLoser],
  },
  {
    name: 'O-Ren',
    src: [ORen, ORenLoser],
  },
  {
    name: 'Stuntman Mike',
    src: [StuntmanMike, StuntmanMikeLoser],
  },
  {
    name: 'Vic Vega',
    src: [VicVega, VicVegaLoser],
  },
  {
    name: 'Vincent Vega',
    src: [VincentVega, VincentVegaLoser],
  },
];

export default Characters;
